import { React, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

const tokenExpired = (token) => {
    // Placeholder for token expiration logic via expiresOn field
    return false;
}
function RequestAccessToken() {

    const { instance, accounts, inProgress } = useMsal();
    const [accessToken, setAccessToken] = useState(null);

    const name = accounts[0] && accounts[0].name;


    const request = {
        ...loginRequest,
        account: accounts[0]
    };

    if(accessToken && !tokenExpired(accessToken)) {
        return Promise.resolve(accessToken);    
    }

    // Silently acquires an access token which is then attached to a request for Microsoft Graph data

    return instance.acquireTokenSilent(request).then((response) => {

        setAccessToken(response);

        console.log("returning token");
        //console.log(response);
        return accessToken;
    }).catch((e) => {
        instance.acquireTokenPopup(request).then((response) => {
            setAccessToken(response.accessToken);

            console.log("returning token after failure");
            //console.log(accessToken);
            return accessToken;
        });
    });

}
export default RequestAccessToken;